import { ApplicationState } from './store/index';
import { History } from 'history';
import { createStore, applyMiddleware, Store } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { rootReducer } from './store';
import thunk from 'redux-thunk';
// import { createLogger } from 'redux-logger';

import { composeWithDevTools } from 'redux-devtools-extension';

export default function configureStore(history: History): Store<ApplicationState> {
  const getMiddleware = () => {
    if (process.env.NODE_ENV === 'production') {
      return applyMiddleware(routerMiddleware(history), thunk);
    } else {
      return applyMiddleware(routerMiddleware(history), thunk);
    }
  };

  const store = createStore(rootReducer(history), composeWithDevTools(getMiddleware()));

  return store;
}



// WEBPACK FOOTER //
// ./src/configureStore.ts